module.exports = __webpack_public_path__ + "img/ina-valve.44a48274.png";